var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box"},[_c('img',{staticClass:"icons",attrs:{"src":_vm.current.icon}}),_c('div',{staticClass:"num"},[_vm._v(" "+_vm._s(this.numHandle(this.calcHandle()))+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }